import { render } from "./ArmourDisplay.vue?vue&type=template&id=2c11422a&scoped=true"
import script from "./ArmourDisplay.vue?vue&type=script&lang=js"
export * from "./ArmourDisplay.vue?vue&type=script&lang=js"

import "./ArmourDisplay.vue?vue&type=style&index=0&id=2c11422a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c11422a"]])

export default __exports__